const PRIVATE_FILE_TYPES = {
  PASSPORT: 'passport',
}

module.exports = PRIVATE_FILE_TYPES;